<template>
  <!-- Ensure you close the vue syntax/component tags with a div as a parent -->
  <!-- Write template here -->
  <div>
    <j-xlsx-table
      v-if="rerender"
      ref="preview"
      :accept="fileTypes"
      :required-columns="required_columns[type]"
      @onClickDownload="onClickDownload"
      @get-files="setFiles"
      @on-select-file="handleSelectedFile">
      {{ placeholder }}
    </j-xlsx-table>
    <b-modal
      ref="myModalRef"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h3>Import Previews</h3>
      <div class="">
        <j-table-preview
          v-if="tableData !== null"
          :invalid-header="invalidHeader"
          :columns="columns"
          :table-data="tableData"
          @importData="importData">
          <b-button
            class="btn grey"
            @click="closeTable">
            Close
          </b-button>
        </j-table-preview>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import jTablePreview from '../jTablePreview';
import jXlsxTable from '../jXlsxTable';

export default {
  name: 'JImportButton',
  components: {
    jTablePreview,
    jXlsxTable,
  },
  props: {
    fileTypes: {
      type: String,
      default: '.xlsx, .xls',
    },
    type: {
      type: String,
      default: 'personal_data',
    },
  },
  data() {
    return {
      rawFile: null,
      workbook: null,
      tableDataPreview: {
        header: [],
        body: [],
      },
      files: [],
      invalidHeader: {},
      tableData: null,
      index: 0,
      count: 1,
      rerender: true,
      columns: null,
      placeholder: 'Import',
      required_columns: {
        personal_data: [
          'No',
          'email',
          'employee_id',
          'auto_generate_id',
          'code_company',
          'personal_email',
          'password',
          'first_name',
          'last_name',
          'other_name',
          'roles',
          'gender',
          'id_type',
          'id_number',
          'id_expired',
          'religion',
          'marital_status',
          'address',
          'postal_code',
          'country_id',
          'province_id',
          'city_id',
          'secretary_mode',
          'secretary_mode_list_team',
          'bank_account_name',
          'bank_account_number',
          'bank_account_owner',
          'bank_account_branch',
          'code',
          'contract_type',
          'type_of_contract',
          'join_date',
          'contract_start_date',
          'resign_date',
          'title',
          'employee_status',
          'active_reason',
          'non_active_reason',
          'location_id',
          'office_address',
          'office_country_id',
          'office_province_id',
          'office_city_id',
          'date_of_birth',
          'place_of_birth',
          'phone_number',
          'about',
          'position_id',
        ],
        employee_documents: ['email', 'documents__document_type', 'documents__name', 'documents__expired_date'],
        family_and_relations: [],
        emergency_contacts: [],
        business_line: ['email', 'business_lines__main', 'business_lines__sub', 'business_lines__co-managers'],
        medical_information: [],
        medical_records: [],
        careers: [],
        education: [],
        self_developments: [],
        track_records: [],
        payroll_data: [],
      },
    };
  },
  computed: {
    rABS() {
      return window.xlsxEventBus.XLSX_EVENTS_DATA.options.rABS;
    },
    ...mapState('jStoreImport', ['invalidHeaderList']),
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem']),
    onClickDownload() {
      this.$emit('onClickDownload');
    },
    onClickImportFile() {
      this.clearAllData();
      this.$refs.uploadInput.click();
      this.$emit('onClickImportFile');
    },
    setFiles(files) {
      this.files = files;
      this.index = Array.from(this.files).length - 1;
    },
    handleSelectedFile(convertedData) {
      if (convertedData === null) {
        this.toggleProblem('Header invalid');
      } else {
        this.rerender = false;
        this.tableData = null;
        this.columns = [];
        this.columns.push(...Object.assign([], convertedData.header));

        this.modifyTableOptions();
        const convertToJson = convertedData.body.map((data) => {
          const dataTable = {};
          for (let i = 0; i < convertedData.header.length; i += 1) {
            dataTable[this.columns[i]] = data[convertedData.header[i]];
          }
          return dataTable;
        });

        this.tableData = convertToJson;
        if (this.type !== 'personal_data') {
          this.tableData.splice(0, 1);
        }
        this.placeholder = this.files[this.index].name;
        setTimeout(() => {
          this.rerender = true;
        }, 0);
        this.$refs.myModalRef.show();
      }
    },
    closeTable() {
      this.index -= 1;
      this.rerender = true;
      this.tableData = null;
      if (this.index >= 0) {
        this.$refs.preview.handleFileChange(this.files, this.index);
      } else {
        this.$refs.myModalRef.hide();
      }
    },
    importData(data) {
      const formData = new FormData();
      formData.append('files[]', this.files[this.index]);
      this.columns.splice(0, 1);
      const payload = {
        file: formData,
        header: this.columns,
        body: data,
      };
      this.$emit('importData', payload);
      this.closeTable();
    },
    modifyTableOptions() {
      this.invalidHeader = {};
      this.$emit('setInvalidHeader', this.columns);
      this.invalidHeaderList.forEach((header) => {
        this.invalidHeader[header] = 'invalid';
      });
    },
  },
  // Wrote all you need down here!
};
</script>

<style lang="scss" scoped>
/* Add scoped style here */
.vue-xlsx-container{
  display: inline-block;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  .c-hide{
    display: none;
  }
}
.c-hide{
  display: none;
}
.xlsx-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #20a0ff;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  padding: 7px 9px;
  font-size: 12px;
  border-radius: 4px;
  color: #fff;
  background-color: #20a0ff;
  &.button-large{
    padding: 10px 15px;
    font-size: 14px;
  }
  &.button-primary{
    color: #1f2d3d;
    border: 1px solid #bfcbd9;
    background-color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/import/buttons/jImportEmployeeButton.vue